import { render, staticRenderFns } from "./ManoDeObraArea.vue?vue&type=template&id=a72a8330"
import script from "./ManoDeObraArea.vue?vue&type=script&lang=js"
export * from "./ManoDeObraArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports